// opervex-frontend/src/Opervex/MaterialManagement/Products.js

class Products {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return await this.#_api.get("/MaterialManagement/Product/" + id);
  }

  async update(id, data) {
    return this.#_api.put("/MaterialManagement/Product/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/MaterialManagement/Product/", data);
  }

  async findAll() {
    return this.#_api.get("/MaterialManagement/Product");
  }

  async findAllByExternalCode(listCodes) {
    return this.#_api.get("/MaterialManagement/Product?externalCode=(" + listCodes.join(", ") + ")");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "unitMeasurement",
        label: "Unidade Base",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "externalCode",
        label: "Código Externo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Products;
